import { format, parseISO } from "date-fns";

import { FormikValues, useFormikContext } from "formik";
import { get } from "lodash";
import { CalendarDateInput, CalendarDateInputProps } from "../components";
interface DateFieldProps {
  name: string;
  label: string;
}

function formatDate(newDate: Date, dateFormat: string) {
  const tempDate = new Date(newDate);
  if (dateFormat === "ISO") return tempDate.toISOString();
  if (dateFormat === "UTC") return tempDate.toUTCString();
  return format(tempDate, dateFormat);
}
function DateField<Value extends FormikValues>({
  name,
  dateFormat = "yyyy-MM-dd",
  ...props
}: DateFieldProps & Omit<CalendarDateInputProps, "onChange" | "selected">) {
  const { setFieldValue, values } = useFormikContext<Value>();
  const selectedDate = get(values, name, undefined);

  const isSelected = selectedDate !== "" && selectedDate;

  return (
    <>
      <CalendarDateInput
        {...props}
        dateFormat={dateFormat}
        autoComplete="off"
        showPopperArrow={false}
        selected={
          isSelected ? parseISO(formatDate(selectedDate, dateFormat)) : null
        }
        onChange={(date) => {
          setFieldValue(name, date ? formatDate(date, dateFormat) : "", true);
        }}
      />
    </>
  );
}
export default DateField;
